import { Injectable } from "@angular/core";
import { deepClone } from '../utils/deep-clone.util';

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor() {}

  numberCheck = function (e) {
    var k;
    document.all ? (k = e.keyCode) : (k = e.which);
    if (!(k == 45 || k == 46 || (k >= 48 && k <= 57))) {
      // ASCII 65 to 90 for A-Z , 97 to 122 for a-z , 8 for backspace, 32 for space, 48 to 57 for 0-9
      e.preventDefault();
    }
  };

  deepCopy = function (obj) {
    obj = obj == undefined ? "" : obj;
    return deepClone(obj);
  };

  isUndefined = function (value) {
    if (value == undefined) return true;
    else return false;
  };

  //Function to restrict user from entering special characters in scenario name and project name
  nameCheck(e) {
    var k;
    document.all ? (k = e.keyCode) : (k = e.which);

    if (
      !(
        (k >= 65 && k <= 90) ||
        (k >= 97 && k <= 122) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57) ||
        k == 37 ||
        k == 45
      )
    ) {
      // ASCII 65 to 90 for A-Z , 97 to 122 for a-z , 8 for backspace, 32 for space, 48 to 57 for 0-9, 37 for %, 45 for -
      e.preventDefault();
    }
  }

  processDataConfig(ndc_data, configArr) {
    const changeData = configArr.map((prd: any) => {
      const ndcPrdData = ndc_data.find(
        (ndc: any) => ndc.Product === prd.Product
      );
      return {
        ...prd,
        isNdcChild: ndcPrdData?.NDC_FLAG === "Y" ? true : false,
        ndcParentName:
          ndcPrdData?.NDC_FLAG === "Y" ? ndcPrdData?.NDC_PARENT : null,
      };
    });
    return changeData;
  }

  displayNDCConfigData(arr, scenarioDetail) {
    const mapWithIndex = new Map();
    const result = [];
    for (const item of arr) {
      const parentName = item.ndcParentName;

      const isSelectedNDCOrProduct = scenarioDetail.find(
        (prd) => item.Product === prd.Competitor
      )?.base?.Include;
      if (!isSelectedNDCOrProduct) continue;

      if (parentName != null) {

        if (!mapWithIndex.has(item.ndcParentName)) {
          mapWithIndex.set(item.ndcParentName, result.length);

          const dataJson = JSON.parse(JSON.stringify(item.data));

          result.push({
            Product: parentName,
            data: dataJson,
            isNdcChild: false,
            ndcParentName: null,
          });
          result.push(item);
        } else {
          const idx = mapWithIndex.get(parentName);

          let parentBrandData = result[idx].data;

          parentBrandData = parentBrandData.map((metric, mtIdx) => {
            let monthlydataSum = metric.data;
            monthlydataSum.deal[0].data = monthlydataSum.deal[0].data.map(
              (val, valIdx) =>
                val + item.data[mtIdx].data.deal[0].data?.[valIdx]
            );
            monthlydataSum.noDeal[0].data = monthlydataSum.noDeal[0].data.map(
              (val, valIdx) =>
                val + item.data[mtIdx].data.noDeal[0].data?.[valIdx]
            );

            if(metric?.Visible === "No"){
              return {
                ...metric,
                data: monthlydataSum
              };
            }
            
            let qtrDataSum = metric.quarterlyData;
            qtrDataSum.deal = qtrDataSum.deal.map(
              (val, valIdx) => val + item.data[mtIdx].quarterlyData.deal[valIdx]
            );
            qtrDataSum.noDeal = qtrDataSum.noDeal.map(
              (val, valIdx) =>
                val + item.data[mtIdx].quarterlyData.noDeal[valIdx]
            );
            let contractYearlyDataSum = metric.contractYearlyData;
            contractYearlyDataSum.deal = contractYearlyDataSum.deal.map(
              (val, valIdx) =>
                val + item.data[mtIdx].contractYearlyData.deal[valIdx]
            );
            contractYearlyDataSum.noDeal = contractYearlyDataSum.noDeal.map(
              (val, valIdx) =>
                val + item.data[mtIdx].contractYearlyData.noDeal[valIdx]
            );
            let yearlyDataSum = metric.yearlyData;
            yearlyDataSum.deal = yearlyDataSum.deal.map(
              (val, valIdx) => val + item.data[mtIdx].yearlyData.deal[valIdx]
            );
            yearlyDataSum.noDeal = yearlyDataSum.noDeal.map(
              (val, valIdx) => val + item.data[mtIdx].yearlyData.noDeal[valIdx]
            );
            let totalContractDataSum = metric.totalContractData;
            totalContractDataSum.deal += item.data[mtIdx].totalContractData.deal;
            totalContractDataSum.noDeal += item.data[mtIdx].totalContractData.noDeal;

            return {
              ...metric,
              data: monthlydataSum,
              quarterlyData: qtrDataSum,
              contractYearlyData: contractYearlyDataSum,
              yearlyData: yearlyDataSum,
              totalContractData: totalContractDataSum,
            };
          });
          result[idx].data = parentBrandData;
          result.push(item);
        }
      } else {
        result.push(item);
      }
    }
    return result;
  }
}
